/* Countdown auf der Produktkachel im Kollektionsraster.

   Ein einziger Taktgeber fuer alle Kacheln: jede Sekunde werden alle
   vorhandenen Timer neu geschrieben. Das ist billiger als ein Intervall
   je Kachel und hat einen praktischen Nebeneffekt - taucht durch einen
   Filterwechsel ein neues Raster auf, wird es beim naechsten Takt
   automatisch mitbedient. Kein MutationObserver noetig.

   Markup dazu: snippets/np-card-countdown.liquid
*/
(function () {
  if (window.__npKachelCountdown) { return; }
  window.__npKachelCountdown = true;

  function zwei(n) { return n < 10 ? '0' + n : '' + n; }

  function schreibe(el) {
    var ziel = new Date(el.getAttribute('data-deadline')).getTime();
    var box = el.closest('[data-np-ccd]');

    // Unbrauchbares Datum oder Termin vorbei: Band verschwindet.
    // Was dann gilt, sagt die Bestandsanzeige - hier steht nichts Falsches.
    if (isNaN(ziel) || ziel - Date.now() <= 0) {
      if (box) { box.remove(); } else { el.remove(); }
      return;
    }

    var s = Math.floor((ziel - Date.now()) / 1000);
    var tage = Math.floor(s / 86400);

    var eT = el.querySelector('[data-t]');
    var eW = el.querySelector('[data-tw]');
    var eH = el.querySelector('[data-h]');
    var eM = el.querySelector('[data-m]');
    var eS = el.querySelector('[data-s]');
    if (!eH || !eM || !eS) { return; }

    // Am letzten Tag faellt die Tagesangabe weg - dann zaehlen Stunden.
    if (tage > 0) {
      if (eT) { eT.textContent = tage; eT.hidden = false; }
      if (eW) { eW.textContent = tage === 1 ? 'Tag' : 'Tage'; eW.hidden = false; }
    } else {
      if (eT) { eT.hidden = true; }
      if (eW) { eW.hidden = true; }
    }
    eH.textContent = zwei(Math.floor((s % 86400) / 3600));
    eM.textContent = zwei(Math.floor((s % 3600) / 60));
    eS.textContent = zwei(s % 60);
  }

  function takt() {
    var alle = document.querySelectorAll('[data-np-ccd-timer]');
    for (var i = 0; i < alle.length; i++) { schreibe(alle[i]); }
  }

  function los() {
    takt();
    setInterval(takt, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
